import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { ChevronRight } from 'react-bootstrap-icons'
import { SportLink } from '../../types/SportLink'
import { Club } from '../../types/club/Club'

interface Props {
    club: Club
    showClubDetail: (club: Club) => void
    className?: string
    selectedSport?: string | null
}

export const ClubCard: React.FC<Props> = ({ club, showClubDetail, className, selectedSport }) => {
    return (
        <Col lg={6} key={club.name} onClick={() => showClubDetail(club)} className={"card-container mb-4" + (className || "")}>
            <Card className="club-card">
                <Card.Body className="club-card-body">
                    <Row className="club-card-body-row">
                        <Col>
                            <Card.Title className="club-card-title">
                                {club.name}
                            </Card.Title>
                            <Row className="club-card-row">
                                <Col className="club-card-column club-contact mb-3">
                                    <div className="contact-person">{club.address.contactPerson}</div>
                                    <div className="primary-email">{club.primaryEmail}</div>
                                </Col>
                                <Col sm className="club-card-column">
                                    {getSports(club.sports, selectedSport)}
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={1} className="align-self-center">
                            <ChevronRight />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    )
}

const getSports = (sports: SportLink[], selectedSport?: string | null) => {
    //only need first 3 items
    const newSports = sports.slice(0, 3).map(sport => sport.name);
    if (selectedSport) {
        if (newSports.includes(selectedSport)) {
            //remove selected sport from array
            newSports.splice(newSports.indexOf(selectedSport), 1);
        } else {
            //remove last element
            newSports.pop();
        }
        newSports.unshift(selectedSport);
    }
    const sportDivs = newSports.map((sport, index) => (
        <div className="sport" key={index}>
            {sport}
        </div>
    ));
    if (sports.length > 3) {
        sportDivs.push(<div key={4}>...</div>)
    }
    return sportDivs;
}